import { registry } from '@cian/mf-registry/browser';
import {
  IPaymentWidgetMicrofrontendAPI,
  IPaymentWidgetParams,
  TPaymentWidgetResult,
} from '../../../../shared/types/microfrontends/paymentWidget';

const paymentWidgetApiCall = async <Params>(path: string, params: Params): Promise<TPaymentWidgetResult> => {
  const api = await registry().microfrontendStrict('payment-widget-frontend').api()!.ensure();

  return api.call(path, params);
};

export const getPaymentWidgetMicrofrontendAPI = (): IPaymentWidgetMicrofrontendAPI => {
  return {
    openPaymentModal: (params: IPaymentWidgetParams) => {
      return paymentWidgetApiCall<IPaymentWidgetParams>('/v1/open-payment-modal', params);
    },
  };
};
